import { Camera } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const PreviewIcon = DeckardIconWrapper({ Icon: Camera });
